/**
 *
 * Platform Drivers
 *
 */
import React, { memo } from "react";
import { BestServiceHero } from "./components/best-service-hero";
import { WhyPlatformDrivers } from "./components/why-platform-drivers";
import { ExclusiveTripleNetwork } from "./components/exclusive-triple-network";
import { ESimActivation } from "./components/eSIM-activation";
import { PlatformDriverPlans } from "./components/platform-driver-plans";
import { FreeServices } from "./components/free-services";
import { SecurityFeaturesTable } from "./components/security-features-table";
import { SecurityPlan } from "./components/security-plan";
import { RealSavings } from "./components/real-savings";
import { ValueYouWontFind } from "./components/value-you-wont-find";
import { PlatformDriversTestimonial } from "./components/platform-drivers-testimonial";
import { ReadyToBoost } from "./components/ready-to-boost";
import { Faq } from "./components/faq";
import { AlwaysConnected } from "./components/always-connected";
import { Footer } from "app/components/AdminLayout/Footer";

interface Props {}

export const PlatformDrivers = memo((props: Props) => {
  return (
    <React.Fragment>
      <main className="overflow-hidden">
        {/* Best Service Hero Section */}
        <BestServiceHero />
        {/* Why Platform Drivers Section */}
        <WhyPlatformDrivers />
        {/* Exclusive Car Tiltle Monitoring & Triple Network access Section */}
        <ExclusiveTripleNetwork />
        {/* Immediate eSIM Activation Section */}
        <ESimActivation />
        {/* Platform Driver Plans Section */}
        <PlatformDriverPlans />
        {/* Free Services Included Section */}
        <FreeServices />
        {/* Security Features Comparison Section */}
        <SecurityFeaturesTable />
        {/* Security Plan Upgrade Section */}
        <SecurityPlan />
        {/* Real Savings Section */}
        <RealSavings />
        {/* Value You Won't Find Anywhere Else Section */}
        <ValueYouWontFind />
        {/* Platform Drivers Testimonial Section */}
        <PlatformDriversTestimonial />
        {/* Ready to Boost Section */}
        <ReadyToBoost />
        {/* Faq Section */}
        <Faq />
        {/* Always Connected, Always Protected Section */}
        {/* <AlwaysConnected /> */}
      </main>
      <Footer />
    </React.Fragment>
  );
});
